import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/faq_categories', { params });
  },
  create(data) {
    return axios.post('/v1/faq_categories', data);
  },
  detail(id) {
    return axios.get(`/v1/faq_categories/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/faq_categories/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/faq_categories/${id}`);
  }
};
